import { combineReducers } from 'redux';
import {
  DELETE_IMAGE,
  SET_FILE,
  SET_TEMP_IMG,
  SET_UPLOAD_IMAGE,
  RESET_UPLOAD_IMAGE_STATE,
} from 'actions/uploadImage/constants';
import createReducer from 'utils/createReducer';

const deleted = createReducer(false, {
  [DELETE_IMAGE]: (draft, { payload }) => payload.deleted,
});

// FIXME potentially unserialisable type
const file = createReducer(null, {
  [SET_FILE]: (draft, { payload }) => payload.file,
  [RESET_UPLOAD_IMAGE_STATE]: () => null,
});

// FIXME wrong default type
const filename = createReducer(null, {
  [SET_UPLOAD_IMAGE]: (draft, { payload }) => payload.filename,
});

// FIXME wrong default type
const tempFileUrl = createReducer(null, {
  [SET_TEMP_IMG]: (draft, { payload }) => payload.tempFileUrl,
});

export default combineReducers({
  deleted,
  file,
  filename,
  tempFileUrl,
});
